import { render, staticRenderFns } from "./timeline_events_tab.vue?vue&type=template&id=79449956"
import script from "./timeline_events_tab.vue?vue&type=script&lang=js"
export * from "./timeline_events_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports